/**
 *  Temporary fix before we unite integration and Skymap's errors into same common/error file.
 */
export type ErrorResponseErrorItemCodeLeica =
  | 'leica_auth:invalid_skymap_token'
  | 'leica_auth:unauthorized_skymap_token'
  | 'leica_auth:project_not_found'
  | 'leica_auth:unknown_error'
  | 'leica_auth:invalid_token'
  | 'leica_connection:not_found'
  | 'leica_connection:leica_project_already_connected'
  | 'leica_connection:leica_session_id_already_exists'
  | 'leica_connection:leica_project_token_already_exists';

export const translations: Record<ErrorResponseErrorItemCodeLeica, string> = {
  'leica_auth:invalid_skymap_token': 'Ett oväntat fel inträffade.',
  'leica_auth:invalid_token': 'Ett oväntat fel inträffade.',
  'leica_auth:project_not_found': 'Ett oväntat fel inträffade.',
  'leica_auth:unauthorized_skymap_token': 'Ett oväntat fel inträffade.',
  'leica_auth:unknown_error': 'Ett oväntat fel inträffade.',
  'leica_connection:leica_project_already_connected': 'Ett oväntat fel inträffade.',
  'leica_connection:leica_project_token_already_exists': 'Ett oväntat fel inträffade.',
  'leica_connection:leica_session_id_already_exists': 'Ett oväntat fel inträffade.',
  'leica_connection:not_found': 'Ett oväntat fel inträffade.',
};
